import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import tabsConstants from "../Constants/TabsConstants";

let result = null;
let inspectionImage = null;
let orderStatus = null;
class TabsStore extends EventEmitter {
  getResult() {
    return result;
  }
  setResult(res) {
    result = res;
  }
  getInspectionImageResult() {
    return inspectionImage;
  }
  setInspectionImageResult(res) {
    inspectionImage = res;
  }
  getOrderStatusResult() {
    return orderStatus;
  }
  setOrderStatusResult(res) {
    orderStatus = res;
  }
  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case tabsConstants.GET_DOCUMENTS_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_DOCUMENTS_FAILURE:
        this.setResult(null);
        break;

      case tabsConstants.GET_EQUIPMENTDETAIL_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_EQUIPMENTDETAIL_FAILURE:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_AUFTRAGSDETAIL_FAILURE:
        this.setResult(action.result);
        break;

      case tabsConstants.ADD_DOCUMENT_SUCCESS:
        this.setResult(true);
        break;
      case tabsConstants.ADD_DOCUMENT_FAILURE:
        this.setResult(false);
        break;
      case tabsConstants.GET_DOCUMENTASBYTE_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_DOCUMENTASBYTE_FAILURE:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_BILD_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_BILD_FAILURE:
        this.setResult(null);
        break;
      case tabsConstants.DELETE_DOCUMENT_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.DELETE_DOCUMENT_FAILURE:
        this.setResult(null);
        break;
      case tabsConstants.GENERIERT_BETR_SUCCESS:
        this.setResult(true);
        break;
      case tabsConstants.GENERIERT_BETR_FAILURE:
        this.setResult(false);
        break;
      case tabsConstants.CHECK_FILEEXISTS_SUCCESS:
        this.setResult(true);
        break;
      case tabsConstants.CHECK_FILEEXISTS_FAILURE:
        this.setResult(false);
        break;
      case tabsConstants.GENERIERT_PRUEFBERICHT_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GENERIERT_PRUEFBERICHT_FAILURE:
        this.setResult(null);
        break;
      case tabsConstants.GET_INSPECTION_IMAGE_SUCCESS:
        this.setInspectionImageResult(action.result);
        break;
      case tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_SUCCESS:
        this.setResult(null);
        break;
      case tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_FAILURE:
        this.setResult(null);
        break;
      case tabsConstants.GET_INSPECTION_IMAGE_FAILURE:
        this.setInspectionImageResult(null);
        break;
      case tabsConstants.GET_ORDER_STATUS_SUCCESS:
        this.setOrderStatusResult(action.result);
        break;
      case tabsConstants.GET_ORDER_STATUS_FAILURE:
        this.setOrderStatusResult(null);
        break;
      case tabsConstants.GET_AUFTRAGSDETAILBYID_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_AUFTRAGSDETAILBYID_FAILURE:
        this.setResult(null);
        break;
      case tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_SUCCESS:
        this.setResult(action.result);
        break;
      case tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const tabsStore = new TabsStore();
dispatcher.register(tabsStore.handleCallback.bind(tabsStore));
export default tabsStore;
